import React, { useState, useRef } from 'react';

const AudioRecorder = () => {
  const [isRecording, setIsRecording] = useState(false);
  const [audioChunks, setAudioChunks] = useState([]);
  const [audioURL, setAudioURL] = useState(null);

  const audioStreamRef = useRef(null);
  const mediaRecorderRef = useRef(null);

  const startRecording = async () => {
    try {
      audioStreamRef.current = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(audioStreamRef.current);
      console.log('start record',mediaRecorderRef.current)

      mediaRecorderRef.current.ondataavailable = (e) => {
        console.log('start ondataavailable',)
        if (e.data.size > 0) {
            console.log('start setAudioChunks',)
          setAudioChunks((prevChunks) => [...prevChunks, e.data]);
        }
      };

      mediaRecorderRef.current.onstop = () => {
        // console.log('start onstop',)
        // const audioBlob = new Blob(audioChunks, { type: 'audio/mpeg' });
        // console.log('start audioBlob',audioBlob);
        // const audioUrl = URL.createObjectURL(audioBlob);
        // setAudioURL(audioUrl);

        setAudioChunks((prevChunks) => {
          // Accumulate all data chunks when the recording is complete
          const audioBlob = new Blob(prevChunks, { type: 'audio/mpeg' });
          console.log('start audioBlob', audioBlob);
            const audioUrl = URL.createObjectURL(audioBlob);
        setAudioURL(audioUrl);
          return prevChunks; // Return the new state
        });
        
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
    } catch (error) {
      console.error('Error accessing microphone:', error);
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      audioStreamRef.current.getTracks().forEach((track) => track.stop());
      setIsRecording(false);
    }else{
        console.error('mediaRecorderRef.current',mediaRecorderRef.current);
    }
  };

const handleGetAudio = () =>{
    console.log('audioChunks',audioChunks)
}

  return (
    <div>
      <button onClick={isRecording ? stopRecording : startRecording}>
        {isRecording ? 'Stop Recording' : 'Start Recording'}
      </button>

      {isRecording && <p>Recording...</p>}

      {audioURL && (
        <div>
          <p>Recording Finished!</p>
          <audio controls src={audioURL} />
          <button onClick={handleGetAudio}> get Audio</button>
        </div>
      )}
    </div>
  );
};

export default AudioRecorder;
